import {
  ApolloClient,
  from,
  HttpLink,
  InMemoryCache,
  split,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { defaultSettings } from "../defaultSettings";
import { setContext } from "@apollo/client/link/context";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { getMainDefinition } from "@apollo/client/utilities";

export const dev = process.env.NODE_ENV === "development";

const httpLink = new HttpLink({
  uri: defaultSettings.graphqlEndpoint,
  // TODO: change to "same-site" if deployed on same site
  // Don't change during dev or using nginx reverse proxy
  credentials: "include",
  includeExtensions: false,
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      if (
        message.includes("UNAUTHENTICATED") ||
        message.includes("Validation error of type") ||
        (path?.includes("getLoggedInUser") &&
          message.includes("PERMISSION_DENIED"))
      ) {
        if (window !== undefined) {
          if (dev) {
            console.error("logged out by server", message);
            localStorage.removeItem("token");
          }
          if (
            typeof window !== "undefined" &&
            window !== undefined &&
            !window?.location?.href?.includes("/login")
          ) {
            // window.location.href = `${window.location.origin}/logout?destination=${window.location.pathname}`;
          }
        }
      }
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
    });
  }

  if (networkError) console.error(`[Network error]: ${networkError}`);
});

const token =
  typeof window !== "undefined" ? localStorage.getItem("token") : undefined;

const authLink = setContext((_, { headers }) => {
  if (dev) {
    const token =
      typeof window !== "undefined" ? localStorage.getItem("token") : undefined;
    // get the authentication token from local storage if it exists
    // return the headers to the context so httpLink can read them
    if (token) {
      return {
        headers: {
          ...headers,
          authorization: `Bearer ${token}`,
        },
      };
    }
    return { headers };
  }
  return { headers };
});

const wsLink =
  typeof window !== "undefined"
    ? new GraphQLWsLink(
        createClient({
          url: defaultSettings.graphqlEndpointSubscriptions,

          connectionParams: token
            ? {
                authorization:
                  process.env.NODE_ENV === "development"
                    ? `Bearer ${token}`
                    : undefined,
              }
            : undefined,
          shouldRetry: () => true,
          retryAttempts: 3,
          on: {
            connected: (connected) => {
              console.log("connected", connected);
            },
            closed: (closed) => {
              console.log("closed", closed);
            },
            error: (error) => {
              console.log("error", error);
            },
          },
        })
      )
    : null;

const splitLink =
  typeof window !== "undefined" && wsLink !== null
    ? split(
        ({ query }) => {
          const definition = getMainDefinition(query);
          return (
            definition.kind === "OperationDefinition" &&
            definition.operation === "subscription"
          );
        },
        wsLink,
        httpLink
      )
    : httpLink;

export const client = new ApolloClient({
  ssrMode: true,
  connectToDevTools: process.env.NODE_ENV === "development",
  cache: new InMemoryCache({
    typePolicies: {
      patientportal_AppointmentProxyMsg: {
        // @ts-ignore
        keyFields: (element) => element!.appointment!.id! as string,
      },
      patientportal_AppointmentRequestProxyMsg: {
        // @ts-ignore
        keyFields: (element) => element!.appointmentRequest!.id! as string,
      },
    },
  }),

  link: from([authLink, errorLink, splitLink]),
  defaultOptions: {
    mutate: {
      errorPolicy: "all",
    },
    query: {
      errorPolicy: "all",
    },
  },
});
